<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title>
          {{ isUpdateMode == true ? $t('update-btn') : $t('save-btn') }}
        </v-card-title>
        <form>
          <v-flex xs12 sm12 style="margin-top: 20px;">
            <v-select
              v-model="selectItemCategory"
              :items="itemCategories"              
              item-text="itemCategoryName"
              item-value="itemCategoryId"
              :sort-by="['itemCategoryId']"
              :sort-desc="[false]"
              return-object
            >
              <template v-slot:label>
                カテゴリ <span class="required-star">*</span>
              </template>
            </v-select>
            
          </v-flex>
          <v-flex sm12>
            <!-- <v-text-field
              v-model="itemName"
              label="商品名"
              v-validate="'required|max:60'"
              :counter="60"
              :error-messages="errors.collect('itemName')"    <=== 이렇게 에러를 조정할수 있다
              data-vv-name="itemName"
              required
            ></v-text-field> -->
            <v-text-field
              v-model="itemName"
            >
              <template v-slot:label>
                商品名 <span class="required-star">*</span>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="janCode"
            >
              <template v-slot:label>
                JANコード <span class="required-star">*</span>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="unitPrice"
              label="単価"
              type="number"
              value="0"
            ></v-text-field>
          </v-flex>          
          <v-flex sm12>
            <v-text-field
              v-model="numberOfStocks"
              label="在庫数"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="orderLimitNumber"
              label="発注制限数"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="quantityInBox"
              label="1段ボールへの入数"
              type="number"
              hint="ばら在庫の場合は0を入力"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode1"
              label="単品JANコード1"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity1"
              label="作りこみ数量1"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode2"
              label="単品JANコード2"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity2"
              label="作りこみ数量2"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode3"
              label="単品JANコード3"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity3"
              label="作りこみ数量3"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>          
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode4"
              label="単品JANコード4"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity4"
              label="作りこみ数量4"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>          
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode5"
              label="単品JANコード5"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity5"
              label="作りこみ数量5"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>          
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode6"
              label="単品JANコード6"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity6"
              label="作りこみ数量6"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>          
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode7"
              label="単品JANコード7"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity7"
              label="作りこみ数量7"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode8"
              label="単品JANコード8"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity8"
              label="作りこみ数量8"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode9"
              label="単品JANコード9"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity9"
              label="作りこみ数量9"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="originalItemJanCode10"
              label="単品JANコード10"
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="builtInQuantity10"
              label="作りこみ数量10"
              type="number"
              value="0"
              min="0"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex sm12>
            <v-text-field
              label="商品イメージ"
              @click="pickFile"
              v-model="fileName"
              prepend-icon="attach_file"
              hint="JPG/PNGファイル"
            ></v-text-field>
            <input
              id="image"
              accept="image/*"
              type="file"
              ref="file"
              style="display: none"
              value="商品イメージ"
              @change="onFileChange($event)"
            />
          </v-flex> -->

          <div style="height: 14px;"></div>

          <v-flex xs12 sm12>
            <v-textarea
              outline
              v-model="remark"
              counter="1000"
              :label="$t('attributes.remark')"
              clearable                
            ></v-textarea>
          </v-flex>            
          
          <!-- 상품 수정화면에서만 보이게 한다 -->
          <!-- <td class="text-xs-right px-2" v-if="(isUpdateMode && user.userGroup == '千葉工場')">
            <v-switch v-model="displayOnScreen" v-if="isUpdateMode" label="発注依頼画面に非表示する" color="info" value="1" hide-details ></v-switch>
          </td> -->

          <v-switch v-model="displayOnScreen" v-if="isUpdateMode" label="発注依頼画面に非表示する" color="info" value="1" hide-details ></v-switch>
          <v-switch v-model="isDeleted" v-if="isUpdateMode" label="廃番" color="info" value="1" hide-details ></v-switch>

          

          <!-- 버튼 영역 -->
          <div class="footer-btns">
            <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-item-maintenance' }">
              <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
            </v-btn>
            <v-btn block color="success" dark @click="isUpdateMode == true ? updateItem() : newItem()" >
              <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>save</v-icon>
              {{ isUpdateMode == true ? $t('update-btn') : $t('save-btn') }}
            </v-btn>
            <v-btn block color="error" dark v-if="isUpdateMode" @click=deleteItem()>
              <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>delete</v-icon>
              完全削除する
            </v-btn>
            <!-- <v-btn block color="primary" dark @click="forwardSendImage()">
              <v-icon dark left>get_app</v-icon>イメージ添付
            </v-btn> -->
            
          </div>
        </form>
      </v-container>
    </v-card>
    <div style="height: 55px;"></div>
    
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import VeeValidate from 'vee-validate'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import { VMoney } from 'v-money'

Vue.use(VeeValidate)

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this

    this.itemCode = this.$route.params.itemCode

    if (this.itemCode != null) {
      console.log('更新モード')
      
      this.isUpdateMode = true
      // getItem on udpate
      let getItemRequest = { itemCode: this.itemCode }
      ServerApiCallService.item(getItemRequest)
        .then((response) => {
          console.log('completed item')
          let itemFromCode = response.data.item
          
          thisObj.selectItemCategory = {
            itemCategoryId: itemFromCode.itemCategoryId,
            // itemCategoryName: itemFromCode.itemCategory.itemCategoryName
          }
          thisObj.itemName = itemFromCode.itemName
          thisObj.janCode = itemFromCode.janCode
          thisObj.unitPrice = itemFromCode.unitPrice
          thisObj.numberOfStocks = itemFromCode.numberOfStocks
          thisObj.orderLimitNumber = itemFromCode.orderLimitNumber
          thisObj.isDeleted = itemFromCode.isDeleted          
          thisObj.quantityInBox = itemFromCode.quantityInBox          
          thisObj.remark = itemFromCode.remark 
          thisObj.builtInQuantity1 = itemFromCode.builtInQuantity1
          thisObj.originalItemJanCode1 = itemFromCode.originalItemJanCode1          
          thisObj.builtInQuantity2 = itemFromCode.builtInQuantity2
          thisObj.originalItemJanCode2 = itemFromCode.originalItemJanCode2
          thisObj.builtInQuantity3 = itemFromCode.builtInQuantity3
          thisObj.originalItemJanCode3 = itemFromCode.originalItemJanCode3
          thisObj.builtInQuantity4 = itemFromCode.builtInQuantity4
          thisObj.originalItemJanCode4 = itemFromCode.originalItemJanCode4
          thisObj.builtInQuantity5 = itemFromCode.builtInQuantity5
          thisObj.originalItemJanCode5 = itemFromCode.originalItemJanCode5
          thisObj.builtInQuantity6 = itemFromCode.builtInQuantity6
          thisObj.originalItemJanCode6 = itemFromCode.originalItemJanCode6
          thisObj.builtInQuantity7 = itemFromCode.builtInQuantity7
          thisObj.originalItemJanCode7 = itemFromCode.originalItemJanCode7
          thisObj.builtInQuantity8 = itemFromCode.builtInQuantity8
          thisObj.originalItemJanCode8 = itemFromCode.originalItemJanCode8
          thisObj.builtInQuantity9 = itemFromCode.builtInQuantity9
          thisObj.originalItemJanCode9 = itemFromCode.originalItemJanCode9
          thisObj.builtInQuantity10 = itemFromCode.builtInQuantity10
          thisObj.originalItemJanCode10 = itemFromCode.originalItemJanCode10
          thisObj.displayOnScreen = itemFromCode.displayOnScreen
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })
    } else {
      console.log('登録モード')
      this.isUpdateMode = false
    }

    ServerApiCallService.itemCategoriesByStatus()
      .then((response) => {
        console.log('completed item categories')
        thisObj.itemCategories = response.data.itemCategories
        // 初期表示時の
        thisObj.loading = false
      })
      .catch((error) => {
        console.log('There was an error:', error.response)
      })
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  methods: {
    forwardSendImage() {
      console.log('forward send image')
      this.$router.push({
        name: 'admin/new-item-send-by-image'
      })
    },
    newItem() {
      let thisObj = this
      thisObj.loading2 = true

      // 시스템 에러메세지 표시 방법
      // if (this.selectItemCategory.itemCategoryId === '#') {
      //   this.$parent.$parent.$parent.showErrorDialog(
      //     'カテゴリが選択されていません'
      //   )
      //   thisObj.loading2 = false
      //   return
      // }

      if (this.selectItemCategory.itemCategoryId == '#') {
        alert('カテゴリを選択してください');
        thisObj.loading2 = false
        return
      }
      if (this.itemName == '') {
        alert('商品名を入力してください');
        thisObj.loading2 = false
        return
      }
      if (this.itemName.trim() == '') {
        alert('商品名を入力してください');
        thisObj.loading2 = false
        return
      }
      if (this.janCode == '') {
        alert('JANコードを入力してください');
        thisObj.loading2 = false
        return
      }
      if (this.janCode.length != 13) {
        alert('JANコードを確認してください');        
        thisObj.loading2 = false
        return
      }
      if (this.unitPrice == '') {
        alert('単価を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.unitPrice < 0) {
        alert('単価を確認してください');
        thisObj.loading2 = false
        return
      }
      if (isNaN(this.unitPrice)) {
        alert('単価を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.numberOfStocks == '') {
        alert('在庫数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.numberOfStocks < 0) {
        alert('在庫数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (isNaN(this.numberOfStocks)) {
        alert('在庫数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.orderLimitNumber == '') {
        alert('発注制限数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.orderLimitNumber < 0) {
        alert('発注制限数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (isNaN(this.orderLimitNumber)) {
        alert('発注制限数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.quantityInBox == '') {
        alert('入り数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.quantityInBox < 0) {
        alert('入り数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (isNaN(this.quantityInBox)) {
        alert('入り数を確認してください');
        thisObj.loading2 = false
        return
      }

      if (this.originalItemJanCode1 != '') {
        if (this.originalItemJanCode1.length != 13) {
          alert('単品JANコード1を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode2 != '') {
        if (this.originalItemJanCode2.length != 13) {
          alert('単品JANコード2を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode3 != '') {
        if (this.originalItemJanCode3.length != 13) {
          alert('単品JANコード3を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode4 != '') {
        if (this.originalItemJanCode4.length != 13) {
          alert('単品JANコード4を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode5 != '') {
        if (this.originalItemJanCode5.length != 13) {
          alert('単品JANコード5を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode6 != '') {
        if (this.originalItemJanCode6.length != 13) {
          alert('単品JANコード6を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode7 != '') {
        if (this.originalItemJanCode7.length != 13) {
          alert('単品JANコード7を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode8 != '') {
        if (this.originalItemJanCode8.length != 13) {
          alert('単品JANコード8を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode9 != '') {
        if (this.originalItemJanCode9.length != 13) {
          alert('単品JANコード9を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode10 != '') {
        if (this.originalItemJanCode10.length != 13) {
          alert('単品JANコード10を確認してください');        
          thisObj.loading2 = false
          return
        }
      }

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        itemCategoryId: this.selectItemCategory.itemCategoryId,
        itemName: this.itemName,
        janCode: this.janCode,
        unitPrice: this.unitPrice,
        numberOfStocks: this.numberOfStocks,
        orderLimitNumber: this.orderLimitNumber,
        quantityInBox: Number(this.quantityInBox),
        remark: this.remark, 
        builtInQuantity1: Number(this.builtInQuantity1),
        originalItemJanCode1: this.originalItemJanCode1,
        builtInQuantity2: Number(this.builtInQuantity2),
        originalItemJanCode2: this.originalItemJanCode2,
        builtInQuantity3: Number(this.builtInQuantity3),
        originalItemJanCode3: this.originalItemJanCode3,
        builtInQuantity4: Number(this.builtInQuantity4),
        originalItemJanCode4: this.originalItemJanCode4,
        builtInQuantity5: Number(this.builtInQuantity5),
        originalItemJanCode5: this.originalItemJanCode5,
        builtInQuantity6: Number(this.builtInQuantity6),
        originalItemJanCode6: this.originalItemJanCode6,
        builtInQuantity7: Number(this.builtInQuantity7),
        originalItemJanCode7: this.originalItemJanCode7,
        builtInQuantity8: Number(this.builtInQuantity8),
        originalItemJanCode8: this.originalItemJanCode8,
        builtInQuantity9: Number(this.builtInQuantity9),
        originalItemJanCode9: this.originalItemJanCode9,
        builtInQuantity10: Number(this.builtInQuantity10),
        originalItemJanCode10: this.originalItemJanCode10
      }
      
      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-item-maintenance',
      }

      ServerApiCallService.itemsPost(request, sendContext)
        .then(() => {
          console.log('completed new item')
          thisObj.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })

      // 예전의 벨리데이션 체크 방법
      // this.$validator.validateAll().then((result) => {
      //   if (!result) {
      //     this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
      //     thisObj.loading2 = false
      //     return
      //   }
      //   ServerApiCallService.itemsPost(request, sendContext)
      //     .then(() => {
      //       console.log('completed new item')
      //       thisObj.loading2 = false
      //     })
      //     .catch((error) => {
      //       console.log('There was an error:', error.response)
      //     })
      // })
    },
    updateItem() {
      let thisObj = this
      thisObj.loading2 = true
      
      console.log("displayOnScreen: ", thisObj.displayOnScreen); // 값1은 안보이게
      console.log("isDeleted: ", thisObj.isDeleted); // 값1은 삭제

      if (this.selectItemCategory.itemCategoryId == '#') {
        alert('カテゴリを選択してください');
        thisObj.loading2 = false
        return
      }
      if (this.itemName == '') {
        alert('商品名を入力してください');
        thisObj.loading2 = false
        return
      }
      if (this.itemName.trim() == '') {
        alert('商品名を入力してください');
        thisObj.loading2 = false
        return
      }
      if (this.janCode == '') {
        alert('JANコードを入力してください');
        thisObj.loading2 = false
        return
      }
      if (this.janCode.length != 13) {
        alert('JANコードを確認してください');        
        thisObj.loading2 = false
        return
      }
      if (typeof(this.unitPrice) != 'number') {
        if (this.unitPrice == '') {
          alert('単価を確認してください');
          thisObj.loading2 = false
          return
        }
      }
      if (this.unitPrice < 0) {
        alert('単価を確認してください');
        thisObj.loading2 = false
        return
      }      
      if (isNaN(this.unitPrice)) {
        alert('単価を確認してください');
        thisObj.loading2 = false
        return
      }
      if (typeof(this.numberOfStocks) != 'number') {
        if (this.numberOfStocks == '') {
          alert('在庫数を確認してください');
          thisObj.loading2 = false
          return
        }
      }      
      if (this.numberOfStocks < 0) {
        alert('在庫数を確認してください');
        thisObj.loading2 = false
        return
      }      
      if (isNaN(this.numberOfStocks)) {
        alert('在庫数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (typeof(this.orderLimitNumber) != 'number') {
        if (this.orderLimitNumber == '') {
          alert('発注制限数を確認してください');
          thisObj.loading2 = false
          return
        }
      }
      if (this.orderLimitNumber < 0) {
        alert('発注制限数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (isNaN(this.orderLimitNumber)) {
        alert('発注制限数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (typeof(this.quantityInBox) != 'number') {
        if (this.quantityInBox == '') {
          alert('入り数を確認してください');
          thisObj.loading2 = false
          return
        }
      }
      if (this.quantityInBox < 0) {
        alert('入り数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (isNaN(this.quantityInBox)) {
        alert('入り数を確認してください');
        thisObj.loading2 = false
        return
      }
      if (this.originalItemJanCode1 != '' && this.originalItemJanCode1 != null) {
        if (this.originalItemJanCode1.length != 13) {
          alert('単品JANコード1を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode2 != '' && this.originalItemJanCode2 != null) {
        if (this.originalItemJanCode2.length != 13) {
          alert('単品JANコード2を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode3 != '' && this.originalItemJanCode3 != null) {
        if (this.originalItemJanCode3.length != 13) {
          alert('単品JANコード3を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode4 != '' && this.originalItemJanCode4 != null) {
        if (this.originalItemJanCode4.length != 13) {
          alert('単品JANコード4を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode5 != '' && this.originalItemJanCode5 != null) {
        if (this.originalItemJanCode5.length != 13) {
          alert('単品JANコード5を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode6 != '' && this.originalItemJanCode6 != null) {
        if (this.originalItemJanCode6.length != 13) {
          alert('単品JANコード6を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode7 != '' && this.originalItemJanCode7 != null) {
        if (this.originalItemJanCode7.length != 13) {
          alert('単品JANコード7を確認してください');        
          thisObj.loading2 = false
          return
        }
      }      
      if (this.originalItemJanCode8 != '' && this.originalItemJanCode8 != null) {
        if (this.originalItemJanCode8.length != 13) {
          alert('単品JANコード8を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode9 != '' && this.originalItemJanCode9 != null) {
        if (this.originalItemJanCode9.length != 13) {
          alert('単品JANコード9を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      if (this.originalItemJanCode10 != '' && this.originalItemJanCode10 != null) {
        if (this.originalItemJanCode10.length != 13) {
          alert('単品JANコード10を確認してください');        
          thisObj.loading2 = false
          return
        }
      }
      
      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        itemCategoryId: this.selectItemCategory.itemCategoryId,
        itemCode: this.itemCode,
        itemName: this.itemName,
        janCode: this.janCode,
        unitPrice: this.unitPrice,
        numberOfStocks: this.numberOfStocks,
        orderLimitNumber: this.orderLimitNumber,
        isDeleted: this.isDeleted == null ? '0' : this.isDeleted,        
        quantityInBox: Number(this.quantityInBox),
        
        remark: this.remark, 
        builtInQuantity1: Number(this.builtInQuantity1),
        originalItemJanCode1: this.originalItemJanCode1,
        builtInQuantity2: Number(this.builtInQuantity2),
        originalItemJanCode2: this.originalItemJanCode2,
        builtInQuantity3: Number(this.builtInQuantity3),
        originalItemJanCode3: this.originalItemJanCode3,
        builtInQuantity4: Number(this.builtInQuantity4),
        originalItemJanCode4: this.originalItemJanCode4,
        builtInQuantity5: Number(this.builtInQuantity5),
        originalItemJanCode5: this.originalItemJanCode5,
        builtInQuantity6: Number(this.builtInQuantity6),
        originalItemJanCode6: this.originalItemJanCode6,
        builtInQuantity7: Number(this.builtInQuantity7),
        originalItemJanCode7: this.originalItemJanCode7,
        builtInQuantity8: Number(this.builtInQuantity8),
        originalItemJanCode8: this.originalItemJanCode8,
        builtInQuantity9: Number(this.builtInQuantity9),
        originalItemJanCode9: this.originalItemJanCode9,
        builtInQuantity10: Number(this.builtInQuantity10),
        originalItemJanCode10: this.originalItemJanCode10,
        displayOnScreen: this.displayOnScreen == null ? '0' : this.displayOnScreen
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-item-maintenance',
      }

      ServerApiCallService.itemsPut(request, sendContext)
        .then(() => {
          console.log('completed update item')
          thisObj.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })
    },
    onFileChange(e) {
      const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }

      if (files.length > 0) {
        this.dispEmptyText = false
        const file = files[0]
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    pickFile() {
      this.$refs.file.click()
    },
    fileUpload() {
      let thisObj = this
      thisObj.loading1 = true
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.set('storeCode', this.selectedStore.storeCode)
      formData.set('shippingDate', this.shippingDate.replace(/\//g, ''))
      console.log('あっぷろーど')
      formData.append('type', 'image/*')
      formData.append('orderFile', this.targetFile)

      // var imagefile = document.querySelector('#image')
      // formData.append('orderFile', imagefile.files[0])

      console.log(this.targetFile)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'sales/new-order-send'
      }

      ServerApiCallService.sendOrderImage(formData, sendContext)
        .then(response => {
          thisObj.loading1 = false
        })
        .catch(error => {
          //   console.log('There was an error:', error.response)
          thisObj.loading1 = false
          //   this.$parent.$parent.$parent.showResultDialog(
          //     '画像送信中にエラーが発生しました',
          //     null
          //   )
        })
    
  },
    deleteItem() {
      if (!confirm("削除してもよろしいですか")) {
        return;
      }

      let thisObj = this
      thisObj.loading2 = true
      
      let request = {
        itemCode: this.itemCode,
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-item-maintenance',
      }

      if (this.selectItemCategory.itemCategoryId == '#') {
        alert('カテゴリを選択してください');
        thisObj.loading2 = false
        return
      }
      
      ServerApiCallService.itemsDelete(request, sendContext)
        .then(() => {
          console.log('completed delete item')
          thisObj.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })      
    },
    forwardMaintenance() {
      this.$router.push({
        name: 'admin/new-item-maintenance',
        params: {},
      })
    },
  },
  data() {
    return {
      quantityInBox: 0,
      isUpdateMode: false,

      targetFile: '',
      fileName: '',

      loader: null,
      loading: true,
      loading2: false,

      
      isDeleted: '0',      
      itemCategories: [],
      selectItemCategory: {
        itemCategoryId: '#',
        itemCategoryName: '全て',
      },
      itemCode: '',
      itemName: '',
      janCode: '',
      unitPrice: 0,
      numberOfStocks: 0,
      orderLimitNumber: 0,
      remark: '',
      builtInQuantity1: 0,
      originalItemJanCode1: '',
      builtInQuantity2: 0,
      originalItemJanCode2: '',
      builtInQuantity3: 0,
      originalItemJanCode3: '',
      builtInQuantity4: 0,
      originalItemJanCode4: '',
      builtInQuantity5: 0,
      originalItemJanCode5: '',
      builtInQuantity6: 0,
      originalItemJanCode6: '',
      builtInQuantity7: 0,
      originalItemJanCode7: '',
      builtInQuantity8: 0,
      originalItemJanCode8: '',
      builtInQuantity9: 0,
      originalItemJanCode9: '',
      builtInQuantity10: 0,
      originalItemJanCode10: '',
      displayOnScreen: '0',

      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
      },

      directives: { money: VMoney },
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  // data: () => ({
  //   dictionary: {
  //     attributes: {
  //       itemName: '商品名'
  //       // custom attributes
  //     },
  //     custom: {
  //       name: {
  //         required: () => '取引先コード can not be empty',
  //         max: '取引先コード field may not be greater than 10 characters'
  //         // custom messages
  //       }
  //     }
  //   }
  // }),

  // mounted() {
  //   this.$validator.localize('en', this.dictionary)
  // }

  // methods: {
  //   submit() {
  //     this.$validator.validateAll()
  //   }
  // }
}
</script>

<style>
.required-star {
  color: red;
}
</style>
